import { FC } from 'react';
import styled from 'styled-components';
import { blenderCss } from '@clds/blender';

// istanbul ignore next
export const StyledIcon = styled.img<{ size: 'sm' | 'md' }>`
  height: ${({ size }) => (size === 'md' ? 40 : 30)}px;
  max-width: initial; // Global styles from console set all "img" tags max-width to 100%, which breaks display of icons here
  padding: ${({ size, theme }) => (size === 'md' ? theme.spacing.xs : 0)};
  width: ${({ size }) => (size === 'md' ? 40 : 30)}px;
  ${blenderCss.populateVariables({ mode: 'solidContrast', variant: 'primary', intensity: 'md' })}
`;

export const ApplicationSvgIcon: FC<React.PropsWithChildren<{ className?: string; size: 'sm' | 'md'; svg: string }>> = ({ className, size, svg }) => (
  <StyledIcon alt="" className={className} size={size} src={svg} />
);
